import { useRef } from 'react'
import {
  Body,
  Footer,
  FooterAction,
  Header,
  HeaderClose,
  HeaderTitle,
  Outer,
} from './drawer-panel.styled'
import useDrawer from 'modules/drawer/state/use-drawer'
import { focusOnElement } from '../drawer/drawer.utils'
import { FAQ_DRAWER_OPENER_DATA_ID } from 'modules/faq/components/faq-drawer-opener'
import { UiIcon } from 'modules/ui/atoms/Icon'
import { useTranslation } from 'next-i18next'

export interface DrawerPanelProps {
  title?: string
  children: React.ReactNode
  closeButtonDataId?: string
}

const DrawerPanel = ({ title, children, closeButtonDataId = '' }: DrawerPanelProps) => {
  const { t } = useTranslation()
  const drawer = useDrawer({ onClose: focusOnElement(FAQ_DRAWER_OPENER_DATA_ID) })
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  const drawerPanelLabels: { [key: string]: string } = {
    designation: t('orderDesignationDrawerOpener.listItem.label', "I'd like to support"),
    dedication: t('orderDedicationDrawerOpener.listItem.label', 'Dedicate a donation'),
    doubleTheDonation: t('OrderDoubleTheDonationDrawerOpener.listItem.label', 'Employer Matching'),
    faq: t('faqDrawerOpener.opener.label', 'Frequently asked questions'),
  }

  return (
    <Outer>
      <Header withBorder={!!title}>
        {title && (
          <>
            <HeaderTitle>
              {drawer.current?.key ? drawerPanelLabels[drawer.current?.key] : title}
            </HeaderTitle>
          </>
        )}
        <HeaderClose ref={closeButtonRef} onClick={drawer.close} data-id={closeButtonDataId}>
          <UiIcon name="close" />
        </HeaderClose>
      </Header>
      {children}
    </Outer>
  )
}

DrawerPanel.Body = Body
DrawerPanel.Footer = Footer
DrawerPanel.FooterAction = FooterAction

export default DrawerPanel
